/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Input, Label, Button, InputSelect, InputCheckbox, Modal, CustomLoading, Breadcrumb, SaveIcon, CustonModal } from "../../../Components";

/* 🔗 SERVICE */
import { AlocacaoServices } from "../../../Services/alocacoesServices";

/* 🧠 REDUX */
import { store } from "../../../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeLoations, changeLoationtypes, changeModal } from "../../../Redux/Actions";

/* 📁 ASSETS*/
import { Excluir } from "../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, ContainerRow, ContainerColumn, ImageIcon, ButtonsContainer, ContainerCheckbox, RowContainer } from "./styles";

/* 🔧 UTILS */
import { FormatPhone, isValidEmail, isValidField, isValidPhone } from "../../../util/validate";

const ViewAlocacoes = () => {
    const { t } = useTranslation();
    let { id } = useParams();

    document.title = t("administrative.sub-items.allocations.view.document-title");

    const navigationFlow =  [
        { text: 'administrative', page: '/adm/alocacoes' },
        { text: 'allocations', page: '/adm/alocacoes' },
        { text: 'allocation', page: null }
    ]

    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [equipamentsAdd, setEquipamentsAdd] = useState([]);
    const [citiesAdd, setCitiesAdd] = useState([]);
    const [alocacao, setAlocacao] = useState();
    const [activeModal, setActiveModal] = useState("");

    const AllEquipaments = useRef([]);
    const AllCities = useRef([]);
    
    const NameField = useRef();
    const TypeField = useRef();
    const SiglaField = useRef();
    const EmailField = useRef();
    const PhoneField = useRef();
    const AddressField = useRef();
    const IsPersonValue = useRef(false);
    const CPFField = useRef();
    const EntityField = useRef();
    const StateField = useRef();
    const CityField = useRef();
    
    const NameValue = useRef();
    const TypeValue = useRef();
    const SiglaValue = useRef();
    const EmailValue = useRef();
    const PhoneValue = useRef();
    const AddressValue = useRef();
    const CPFValue = useRef();
    const EntityValue = useRef();
    const CityValue = useRef();
    
    const Services = useRef(new AlocacaoServices());

    const user = useSelector(state => state.userReducer);
    const Locations = useSelector(state => state.UserCurdReducer.Locations);
    const LocationTypes = useSelector(state => state.UserCurdReducer.LocationTypes);

    useEffect(() => {
        // Busca dados do usuário
        const getAlocacao = async() => {
            setLoading(true)
            let currentalocacao = await Services.current.getAlocacao(id);
            if(currentalocacao){
                setAlocacao(currentalocacao);

                try {
                    EntityField.current.value = currentalocacao.entity_id ? currentalocacao.entity.id : currentalocacao.group ? currentalocacao.group.id : '';
    
                    NameField.current.getInputDOMNode().value = currentalocacao.name;
                    
                    TypeField.current.value = currentalocacao.type.id;
        
                    SiglaField.current.getInputDOMNode().value = currentalocacao.subtitle;
                } catch (error) {
                    
                }

                await getLocations(currentalocacao.type.id);
                setTimeout(() => {
                    if(TypeField?.current?.value === '6f9d2274-09ed-45d8-96b3-11ee4073da51'){
                        try {
                            EmailField.current.getInputDOMNode().value = currentalocacao.email ? currentalocacao.email : '';
                
                            PhoneField.current.setInputValue(FormatPhone(currentalocacao.phone ? currentalocacao.phone : ''));
            
                            AddressField.current.getInputDOMNode().value = currentalocacao.address ? currentalocacao.address : '';
                        } catch (error) {
                            
                        }
                    }
                }, 20);

                getStates();
                if(TypeField?.current?.value === '941685e4-0fe4-465e-b976-485443cfbb8e' || currentalocacao.city?.code_ibge){
                    await ChangeCities(currentalocacao.city.state.code_uf);
                    try {
                        StateField.current.value = currentalocacao.city.state.code_uf;
                        
                        setTimeout(() => {
                            CityField.current.value = currentalocacao.city.code_ibge;
                        }, 40);
                    } catch (error) {
                        
                    }
                }
            }
            setLoading(false);
            getEquipamentsAndCities();
        }

        const getStates = async() => {
            try {
                let States = await Services.current.getStates();
                setStates(States);
            } catch (error) {
                
            }
        }

        // Busca alocações do usuário
        const getLocations = async(currenttype) => {
            let LocationsTypes = [];

            try {
                if (user?.user?.can?.includes('role.edit')) {
                    LocationsTypes = await Services.current.getLocationsType();
                }
                store.dispatch(changeLoationtypes(LocationsTypes));
                let AllLocations = await Services.current.getLocations();
                if(currenttype === '6f9d2274-09ed-45d8-96b3-11ee4073da51'){
                    store.dispatch(changeLoations([]));
                }else{
                    let newtype = currenttype === '153b08f5-3bac-4614-a325-70f2cc84adc7' ? 'Entidades' : currenttype === '941685e4-0fe4-465e-b976-485443cfbb8e' ? 'Grupos' : ''
                    store.dispatch(changeLoations(AllLocations[newtype]));
                }
            } catch (error) {
                
            }
        }

        const getEquipamentsAndCities = async() => {
            try {
                let Equipaments = await Services.current.getEquipaments(id);
                let Cities = await Services.current.getAllCities(id);
                AllEquipaments.current = Equipaments;
                AllCities.current = Cities;
                setEquipamentsAdd(Equipaments);
                setCitiesAdd(Cities);
            } catch (error) {
                setEquipamentsAdd([]);
                setCitiesAdd([]);
            }
        }

        getAlocacao();
    }, [id]);

    // method-spoofing
    // Salva as edições do usuário
    const Save = async() => {
        if(isValidField(NameField.current.getInputDOMNode().value) && isValidField(SiglaField.current.getInputDOMNode().value) && isValidField(TypeField.current.value)){
            let form = new FormData();
            
            if(NameValue.current){form.append('name', NameValue.current)}
            if(SiglaValue.current){form.append('subtitle', SiglaValue.current)}
            if(TypeValue.current){form.append('type', TypeValue.current)}
            if(CityValue.current){form.append('city_code', CityValue.current)}
            if(TypeField.current?.value === '941685e4-0fe4-465e-b976-485443cfbb8e'){
                if(EntityValue.current){form.append('group_id', EntityValue.current)}
            }else if(TypeField.current?.value === '153b08f5-3bac-4614-a325-70f2cc84adc7'){
                if(EntityValue.current){form.append('entity_id', EntityValue.current)}
            }else if(TypeField.current?.value === '6f9d2274-09ed-45d8-96b3-11ee4073da51'){
                if(IsPersonValue.current){  
                    form.append('is_person', IsPersonValue.current === true ? '1' : '0');
                    if(CPFValue.current){form.append('cpf', CPFValue.current)}
                }else{
                    form.append('is_person', IsPersonValue.current === true ? '1' : '0');
                    if(CPFValue.current){form.append('cnpj', CPFValue.current)}
                }
                if(EmailValue.current){form.append('email', EmailValue.current)}
                if(PhoneValue.current){form.append('phone', PhoneValue.current)}
                if(AddressValue.current){form.append('address', AddressValue.current)}
            }
    
            form.append('_method', 'PATCH');
            Services.current.editAlocacao(id, form);
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    const ChangeCities = async(state) => {
        try {
            let Cities = await Services.current.getCities(state);
            setCities(Cities);
        } catch (error) {
            
        }
    }

    // Filtra equipamentos
    const filterEquipaments = (equipamentName) => {
        let filter = AllEquipaments.current.filter((equipament) => equipament.name.toLowerCase().includes(equipamentName.toLowerCase()));
        setEquipamentsAdd(filter)
    }

    // Filtra cidades
    const filterCities = (cityName) => {
        let filter = AllCities.current.filter((cidade) => cidade.name.toLowerCase().includes(cityName.toLowerCase()));
        setCitiesAdd(filter)
    }

    return (
        <>  
            <Container>
                <Breadcrumb flow={navigationFlow}/>
                <TitleContainer>
                    <Title>{alocacao?.name}</Title>
                </TitleContainer>

                {loading ?
                    <CustomLoading width={'150px'} height={'150px'}/>    
                    :
                <ContainerRow onSubmit={(e) => e.preventDefault()}>

                    <ContainerColumn>
                        <Label text={t("inputs.name.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='name' 
                            name='name' 
                            type="text" 
                            placeholder={t("inputs.name.placeholder")}
                            innerRef={NameField}
                            value={alocacao?.name}
                            invalidMessage={t("inputs.name.invalid-message")}
                            validationFunction={(text) => isValidField(text)}
                            onchange={(text) => {
                                NameValue.current = text
                                setAlocacao({...alocacao, name: text})}}> 
                        </Input>

                        {TypeField.current?.value !== '6f9d2274-09ed-45d8-96b3-11ee4073da51' ?
                            <>
                                <Label text={t("inputs.belongs-to.label")} aling="flex-start"/>
                                <InputSelect
                                    name={'entity_id'}
                                    id={'entity_id'}
                                    placeholder={t("inputs.belongs-to.placeholder")}
                                    invalidMessage={t("inputs.belongs-to.invalid-message")}
                                    options={Locations}
                                    innerRef={EntityField}
                                    value={alocacao?.entity ? alocacao.entity.id : alocacao?.group ? alocacao.group.id : ''}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => { 
                                        alocacao?.entity ? 
                                            setAlocacao({...alocacao, entity: {...alocacao.entity, id: value},}) : 
                                            setAlocacao({...alocacao, group: {...alocacao.group, id: value}})
                                        EntityValue.current = value
                                    }}>
                                </InputSelect>
                            </>
                        :<>
                            <Label text={t("inputs.cpf/cnpj.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='cpf' 
                                name='cpf' 
                                type="text" 
                                placeholder={t("inputs.cpf/cnpj.placeholder")}
                                innerRef={CPFField}
                                invalidMessage={t("inputs.cpf/cnpj.invalid-message")}
                                value={alocacao?.cpf || ''}
                                validationFunction={(text) => isValidField(text)}
                                onchange={(text) => CPFValue.current = text}> 
                            </Input>

                            <InputCheckbox text={t("checkbox.natural-person")} checked={alocacao?.is_person} onChange={(value) => {IsPersonValue.current = value; return true}}/>
                        </>}
                    </ContainerColumn>

                    <ContainerColumn>
                        <Label text={t("inputs.acronym.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='sigla' 
                            name='sigla' 
                            type="text" 
                            placeholder={t("inputs.acronym.placeholder")}
                            innerRef={SiglaField}
                            invalidMessage={t("inputs.acronym.invalid-message")}
                            value={alocacao?.subtitle}
                            validationFunction={(text) => isValidField(text)}
                            onchange={(text) => {
                                SiglaValue.current = text
                                setAlocacao({...alocacao, subtitle: text})}}> 
                        </Input>

                        {TypeField.current?.value === '6f9d2274-09ed-45d8-96b3-11ee4073da51' ?
                            <>
                                <Label text={t("inputs.email.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='email' 
                                    name='email' 
                                    type="text" 
                                    placeholder={t("inputs.email.placeholder")}
                                    innerRef={EmailField}
                                    invalidMessage={t("inputs.email.invalid-message")}
                                    value={alocacao?.email}
                                    validationFunction={(text) => isValidEmail(text)}
                                    onchange={(text) => EmailValue.current = text}> 
                                </Input>

                                <Label text={t("inputs.phone.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='telefone' 
                                    name='telefone' 
                                    type="text" 
                                    mask="(99) 99999-9999"
                                    placeholder={t("inputs.phone.placeholder")}
                                    innerRef={PhoneField}
                                    invalidMessage={t("inputs.phone.invalid-message")}
                                    value={alocacao?.phone || ''}
                                    validationFunction={(text) => isValidPhone(text)}
                                    onchange={(text) => PhoneValue.current = text}> 
                                </Input>
                            </>
                        :<></>}
                        
                        {TypeField.current?.value === '941685e4-0fe4-465e-b976-485443cfbb8e' ?
                            <>
                                <Label text={t("inputs.state.label")} aling="flex-start"/>
                                <InputSelect
                                    name={'state'}
                                    id={'state'}
                                    placeholder={t("inputs.state.placeholder")}
                                    invalidMessage={t("inputs.state.invalid-message")}
                                    options={states}
                                    innerRef={StateField}
                                    value={alocacao?.city?.state?.code_uf}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => {
                                        setAlocacao({...alocacao, city: {state: {code_uf: value}}});
                                        setCities([]);
                                        ChangeCities(value);
                                    }}>
                                </InputSelect>
                            </>
                        :<></>}
                    </ContainerColumn>

                    <ContainerColumn>
                        <Label text={t("inputs.allocation-type.label")} aling="flex-start"/>
                        <InputSelect
                            name={'type'}
                            id={'type'}
                            placeholder={t("inputs.allocation-type.placeholder")}
                            invalidMessage={t("inputs.allocation-type.invalid-message")}
                            disabled={true}
                            value={alocacao?.type?.id}
                            options={LocationTypes?.length ? LocationTypes : [alocacao?.type]}
                            innerRef={TypeField}
                            validationFunction={(value) => isValidField(value)}
                            onchange={(value) => {
                                TypeValue.current = value;
                                setAlocacao({...alocacao, type: {value}});
                                Services.current.ChangeLocationType(value, EntityField.current);
                            }}>
                        </InputSelect>

                        {TypeField.current?.value === '6f9d2274-09ed-45d8-96b3-11ee4073da51' ?
                            <>
                                <Label text={t("inputs.address.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='address' 
                                    name='address' 
                                    type="text" 
                                    placeholder={t("inputs.address.placeholder")}
                                    innerRef={AddressField}
                                    invalidMessage={t("inputs.address.invalid-message")}
                                    value={alocacao?.address || ''}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => AddressValue.current = text}> 
                                </Input>
                            </>
                        :<></>}

                        {TypeField.current?.value === '941685e4-0fe4-465e-b976-485443cfbb8e' ?
                            <>
                                <Label text={t("inputs.city.label")} aling="flex-start"/>
                                <InputSelect
                                    name={'city'}
                                    id={'city'}
                                    placeholder={t("inputs.city.placeholder")}
                                    invalidMessage={t("inputs.city.invalid-message")}
                                    options={cities}
                                    innerRef={CityField}
                                    value={alocacao?.city?.code_ibge}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => {
                                        setAlocacao({...alocacao, city: {code_ibge: value}});
                                        CityValue.current = value;
                                    }}>
                                </InputSelect>
                            </>
                        :<></>}

                    </ContainerColumn>

                </ContainerRow>}

                <ButtonsContainer>
                    {user?.user?.can?.includes('allocation.edit') ?
                        <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={() => Save()}/>
                        :<></>}
                    {user?.user?.can?.includes('allocation.delete') ?
                        <Button text={t("buttons.delete")} width={'150px'} color={'white-red'} onClick={() => setActiveModal('delete-allocation')} icon={<ImageIcon src={Excluir}/>}/>
                        :<></>}
                </ButtonsContainer>

                {user?.user?.can?.includes('administrador.adm') &&
                    <ButtonsContainer>
                        {equipamentsAdd.length > 0 &&
                            <Button text={t("buttons.equipments")} width={'150px'} onClick={() => store.dispatch(changeModal('equipamentos'))}/>
                        }
                        {citiesAdd.length > 0 &&
                            <Button text={t("buttons.cities")} width={'150px'} onClick={() => store.dispatch(changeModal('cities'))}/>
                        }
                    </ButtonsContainer>
                }
            </Container>

            <CustonModal Title={t("modal.delete-allocation.title")} Active={activeModal === 'delete-allocation'}>
                <RowContainer>
                    <Button width={'fit-content'} text={t("buttons.confirm")} disabled={true}/>
                    <Button $borderRadius={'10px'} text={t("buttons.cancel")} color={'white-red'} onClick={() => setActiveModal('')}> {t("buttons.cancel")} </Button>
                </RowContainer>
            </CustonModal>

            {user?.user?.can?.includes('administrador.adm') &&
                <>
                    <Modal title={'Adicionar equipamento para visualização '} name={'equipamentos'} width={'60%'} height={'80%'} >

                        <Label text="Nome do equipamento" aling="flex-start"/>
                        <Input
                            aling="flex-start"
                            id='equipamentName'
                            name='equipamentName'
                            type="text"
                            placeholder="Nome do equipamento"
                            validationFunction={(text) => isValidField(text)}
                            onchange={(text) => filterEquipaments(text)}>
                        </Input>
                        
                        <ContainerCheckbox onSubmit={(e) => e.preventDefault()}>
                            { 
                                equipamentsAdd.map((item, index) => (
                                    <InputCheckbox key={index} id={item.id} name={item.id} text={item.name} checked={alocacao?.extraEquipments?.some(element => element.id === item.id)} 
                                        onChange={async(value) => {
                                            if(value){
                                                await Services.current.addEquipamentToAlocacao(alocacao.id, item.id);
                                                item.checked = value;
                                                return true;
                                            }else{
                                                await Services.current.removeEquipamentFromAlocacao(alocacao.id, item.id);
                                                item.checked = value;
                                                return true;
                                            }
                                        }}/>
                                ))
                            }
                        </ContainerCheckbox>
                        
                    </Modal>

                    <Modal title={'Adicionar Cidade na alocação'} name={'cities'} width={'60%'} height={'80%'} >
                        
                        <ContainerCheckbox onSubmit={(e) => e.preventDefault()}>
                            <Label text="Nome da cidade" aling="flex-start"/>
                            <Input
                                aling="flex-start"
                                id='cityName'
                                name='cityName'
                                type="text"
                                placeholder="Nome da cidade"
                                validationFunction={(text) => isValidField(text)}
                                onchange={(text) => filterCities(text)}>
                            </Input>
                            {citiesAdd.map((item, index) => (
                                    <InputCheckbox key={index} id={item.code_ibge} name={item.code_ibge} text={item.name} checked={alocacao?.cities?.some(eelement => eelement.code_ibge === item.code_ibge)} 
                                        onChange={async(value) => {
                                            if(value){
                                                await Services.current.addCityToAlocacao(alocacao.id, item.code_ibge);
                                                item.checked = value;
                                                return true;
                                            }else{
                                                await Services.current.removeCityFromAlocacao(alocacao.id, item.code_ibge);
                                                item.checked = value;
                                                return true;
                                            }
                                        }}/>
                                ))
                            }
                        </ContainerCheckbox>
                    </Modal>
                </>
            }
        </>
    );
}

export default ViewAlocacoes;